import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { ContentSections } from "@/components/public/ContentSections";
import { PageHero } from "@/components/public/Ui";
import { DEFAULT_TEAM_PAGE } from "@/lib/teamDefaults";

export default function Team() {
  const [page, setPage] = useState(DEFAULT_TEAM_PAGE);

  useEffect(() => {
    api
      .get("/public/pages/team")
      .then((r) => setPage(r.data))
      .catch(() => setPage(DEFAULT_TEAM_PAGE));
  }, []);

  const hero = page.body_json?.hero || {};

  return (
    <>
      <Seo
        title={page.seo_title || "Board of Directors | Bahamas Kidney Association"}
        description={page.seo_description}
        canonicalPath="/team"
      />
      <PageHero
        overline={hero.overline || "Our Leadership"}
        line1={hero.heading_line_1 || "Meet the People"}
        line2={hero.heading_line_2 || "Behind the Mission."}
        subheading={hero.subheading}
        image={page.hero_image_url}
      />
      <div className="bka-container max-w-6xl py-14 lg:py-20" data-testid="page-team">
        <ContentSections sections={page.body_json?.sections || []} />
      </div>
    </>
  );
}
